import angular from 'angular';
import template from './brandsAdminSettingsForm.html';
import './brandsAdminSettingsForm.scss';

export class BrandsAdminSettingsFormController {
  constructor(appUtils) {
    'ngInject';

    this.appUtils = appUtils;

    this.steps = [
      {
        id: 'users',
        label: 'Users',
        step: 0,
        disabled: true,
        completed: true,
      },
      {
        id: 'permissions',
        label: 'Permissions',
        step: 1,
        disabled: true,
        completed: false,
      },
      {
        id: 'confirm',
        label: 'Confirm',
        step: 2,
        disabled: true,
        completed: true,
      },
    ]
    .sort(this.appUtils.sortObjectsList('step'));
    this.stepsTypes = {};
    this.steps.forEach((step) => {
      this.stepsTypes[step.id] = step;
    });

    this.currentStep = 0;
    this.disabledBack = true;
    this.onLastStep = false;
    this.usersQuery = '';
    this.usersResults = [];
    this.usersToggleAllFlag = true;

    this.permissionsQuery = '';
    this.permissionsResults = [];
    this.showPermissionsTitles = true;
    this.showListsActions = false;
    this.confirmInfo = {
      users: [],
      scopes: [],
    };

    this.selectCurrentStep();
  }
  $onChanges(changes) {
    if (changes.loading && !changes.loading.currentValue) {
      this.calculateUserToggleAllFlag();
      this.validatePermissions();
    }
  }
  selectCurrentStep() {
    this.steps.forEach((option, index) => {
      option.disabled = index !== this.currentStep;
    });

    this.disableBack = this.currentStep === 0;
    this.onLastStep = this.currentStep === (this.steps.length - 1);
  }
  willLoadConfirmStep() {
    this.confirmInfo.users = this.savedUsers
    .map((userId) => this.users.find((user) => user.id === userId));
    this.confirmInfo.scopes = [];
    this.scopes.forEach((scope) => {
      const selectedPermissions = scope.permissions
      .filter((permission) => this.savedPermissions.includes(permission.id));

      if (selectedPermissions.length) {
        this.confirmInfo.scopes.push({
          id: scope.id,
          title: scope.title,
          permissions: selectedPermissions,
          all: selectedPermissions.length === scope.permissions.length,
        });
      }
    });
  }
  searchUsers(text) {
    const query = text.toLowerCase();
    if (query !== this.usersQuery) {
      this.usersQuery = query;
      if (this.usersQuery) {
        this.usersResults = this.users.filter(({
          name,
          email,
        }) => name.toLowerCase().includes(this.usersQuery) ||
          email.toLowerCase().includes(this.usersQuery));
      }

      this.calculateUserToggleAllFlag();
    }
  }
  toggleUser(entity, isSelected) {
    this.onToggleUser({
      user: entity,
      isSelected,
    });

    this.calculateUserToggleAllFlag();
  }
  toggleUsersList() {
    this.onToggleUsersList({
      users: this.usersQuery ? this.usersResults : this.users,
      selectAll: this.usersToggleAllFlag,
    });

    this.usersToggleAllFlag = !this.usersToggleAllFlag;
  }
  calculateUserToggleAllFlag() {
    this.usersToggleAllFlag = this._calculateToggleAllFlag(
      this.usersQuery ? this.usersResults : this.users,
      this.savedUsers,
    );
  }
  togglePermission(permission, isSelected) {
    this.onTogglePermission({
      permission,
      isSelected,
    });

    this.validatePermissions();
  }
  validatePermissions() {
    this.stepsTypes.permissions.completed = !!this.savedPermissions.length;
  }
  goBack() {
    const prevStep = this.currentStep - 1;
    if (prevStep >= 0) {
      this.currentStep = prevStep;
      this.disableBack = prevStep === 0;
      this.selectCurrentStep();
    }
  }
  next() {
    const nextStep = this.currentStep + 1;
    if (this.steps[nextStep]) {
      this.currentStep = nextStep;
      this.disableBack = false;
      this.selectCurrentStep();
      const name = this.appUtils.capitalize(this.steps[nextStep].id);
      const method = `willLoad${name}Step`;
      if (angular.isFunction(this[method])) {
        this[method]();
      }
    }
  }
  get disableNext() {
    return !this.steps[this.currentStep].completed;
  }
  _calculateToggleAllFlag(list, savedIds) {
    const selected = list.filter((item) => savedIds.includes(item.id)).length;
    let result = true;
    if (selected) {
      const halfDivider = 2;
      const half = Math.round(list.length / halfDivider);
      result = selected < half;
    }

    return result;
  }
}

export default {
  controller: BrandsAdminSettingsFormController,
  template,
  bindings: {
    loading: '<',
    onCancel: '&',
    onSave: '&',

    users: '<',
    savedUsers: '<',
    onToggleUser: '&',
    onToggleUsersList: '&',

    scopes: '<',
    savedPermissions: '<',
    onTogglePermission: '&',
  },
};
